import { render } from "./PartnerManageView.vue?vue&type=template&id=1f74f815&scoped=true"
import script from "./PartnerManageView.vue?vue&type=script&lang=js"
export * from "./PartnerManageView.vue?vue&type=script&lang=js"

import "./PartnerManageView.vue?vue&type=style&index=0&id=1f74f815&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f74f815"]])

export default __exports__